import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { MdKeyboardArrowRight, MdKeyboardArrowDown, MdTimeline } from "react-icons/md";
import { incidentTypes, severities } from "../CONSTANTS";
import EvidenceDetailsInfo from "../EvidenceDetailsInfo";
import { withRouter } from "react-router-dom";
import { staffType as StaffType } from "../CONSTANTS";
import { bodyLabel } from "app/Components/BodyPartComponent/CONSTANT";
import { BodyPartView } from "../ViewIncidentReport";
import { DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";

const IncidentDetailsInfo = ({
  incidentId,
  type,
  incidentDate,
  reportDate,
  site,
  state,
  department,
  functionData,
  workArea,
  severity,
  fireInvolved,
  facilityOutage,
  permanentDisability,
  facilityShutdown,
  explosion,
  longDurationFire,
  equipmentFailure,
  fallOfObject,
  inundation,
  indirectLosses,
  facilityStatus,
  similarIncidentHappened,
  summary,
  description,
  measuresOrActions,
  fatalityEmployees,
  fatalityContractors,
  fatalityOthers,
  injuredEmployees,
  injuredContractors,
  injuredOthers,
  lostManhoursEmployees,
  lostManhoursContractors,
  lostManhoursOthers,
  personalDetails = [],
  assetDetails = [],
  vehicleDetails = [],
  spills = [],
  evidences = [],
  regionalOffice,
  staffType,
  staffEmployer,
  staffName,
  area,
  subArea,
  shift,
  activity,
  subActivity,
  capasDetails,
  subAreaId,
  otherSubArea,
  locationSiteId,
  roSiteId,
  contractors,
  alcoholViolator,
  ppeViolator,
  unfitBuyerTruck,
  unfitHEMM,
}) => {
  const [panelIndex, setPanelIndex] = useState(0);
  const customOnClick = (eventKey) => {
    setPanelIndex(eventKey === panelIndex ? null : eventKey);
  };
  return (
    <div className="rightIncidentCard">
      <Accordion defaultActiveKey="0" className="incidentDetailAcc">
        <div>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="0"
            onClick={() => customOnClick(0)}
            className={panelIndex === 0 ? "active" : ""}
          >
            Incident Info
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <ul style={{ listStyle: "none" }} className="p-0">
                <li>
                  <span className="txtgrey">Incident ID:</span>
                  <span className="rightData">{incidentId}</span>
                </li>
                <li>
                  <span className="txtgrey">Incident Type:</span>
                  <span className="rightData">{incidentTypes[type]}</span>
                </li>
                <li>
                  <span className="txtgrey">Incident Severity:</span>
                  <span className="rightData">{severities[severity]}</span>
                </li>
                <li>
                  <span className="txtgrey">Incident Date & Time:</span>
                  <span className="rightData">{DDMMYYYYHHMMAFormat(incidentDate)}</span>
                </li>
                <li>
                  <span className="txtgrey">Reported Date & Time:</span>
                  <span className="rightData">{DDMMYYYYHHMMAFormat(reportDate)}</span>
                </li>
                <li>
                  <span className="txtgrey">Location Name:</span>
                  <span className="rightData">{site?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Regional Office:</span>
                  <span className="rightData">{regionalOffice?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Staff Type:</span>
                  <span className="rightData">{StaffType[staffType]}</span>
                </li>
                <li>
                  <span className="txtgrey">Staff Employer:</span>
                  <span className="rightData">{staffEmployer}</span>
                </li>
                <li>
                  <span className="txtgrey">Staff Name:</span>
                  <span className="rightData">{staffName}</span>
                </li>
                <li>
                  <span className="txtgrey">Area :</span>
                  <span className="rightData">{area?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Sub Area:</span>
                  <span className="rightData">
                    {+subAreaId !== 999 ? subArea?.name : "Other"}
                  </span>
                </li>
                {+subAreaId === 999 && (
                  <li>
                    <span className="txtgrey">Other Sub Area:</span>
                    <span className="rightData">{otherSubArea}</span>
                  </li>
                )}

                <li>
                  <span className="txtgrey">Shift:</span>
                  <span className="rightData">{shift}</span>
                </li>
                <li>
                  <span className="txtgrey">Activity:</span>
                  <span className="rightData">{activity?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Sub Activity:</span>
                  <span className="rightData">{subActivity?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Department:</span>
                  <span className="rightData">{department?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">Location ID:</span>
                  <span className="rightData">{locationSiteId}</span>
                </li>
                <li>
                  <span className="txtgrey">RO ID:</span>
                  <span className="rightData">{roSiteId}</span>
                </li>
                <li>
                  <span className="txtgrey">Country</span>
                  <span className="rightData">{state?.country_master?.name}</span>
                </li>
                <li>
                  <span className="txtgrey">State:</span>
                  <span className="rightData">{state?.name}</span>
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </div>
        <div>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="2"
            onClick={() => customOnClick(2)}
            className={panelIndex === 2 ? "active" : ""}
          >
            General Info
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <ul style={{ listStyle: "none" }} className="p-0">
                <li className="w-100">
                  <span className="txtgrey">Fire Involved:</span>
                  <span className="rightData">{fireInvolved ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">
                    Whether plant shut down caused Outage of the Facility:
                  </span>
                  <span className="rightData">{facilityOutage ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">
                    Fatality/permanent loss of body part or permanent disability:
                  </span>
                  <span className="rightData">{permanentDisability ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Shutdown of plant/facility:</span>
                  <span className="rightData">{facilityShutdown ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Blow out or explosion:</span>
                  <span className="rightData">{explosion ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Fire more than 15 minutes duration:</span>
                  <span className="rightData">{longDurationFire ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">
                    Failure of rig critical equipment like draw-works:
                  </span>
                  <span className="rightData">{equipmentFailure ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Checkbox 8:</span>
                  <span className="rightData">{fallOfObject ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Checkbox 9:</span>
                  <span className="rightData">{inundation ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Alcohol Violator:</span>
                  <span className="rightData">{alcoholViolator ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">PPE Violator:</span>
                  <span className="rightData">{ppeViolator ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Unfit Buyer's Truck:</span>
                  <span className="rightData">{unfitBuyerTruck ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Unfit HEMM:</span>
                  <span className="rightData">{unfitHEMM ? "Yes" : "No"}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Indirect Losses:</span>
                  <span className="rightData">{indirectLosses}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Mine - Activity Operations Status:</span>
                  <span className="rightData">{facilityStatus}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">
                    Whether similar incident happened in the past at same location:
                  </span>
                  <span className="rightData">
                    {similarIncidentHappened ? "Yes" : "No"}
                  </span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Incident - Short Summary:</span>
                  <span className="rightData">{summary}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">Incident - Detailed Description:</span>
                  <span className="rightData">{description}</span>
                </li>
                <li className="w-100">
                  <span className="txtgrey">
                    Immediate Measures/Action Taken (Do not enter CAPA here):
                  </span>
                  <span className="rightData">{measuresOrActions}</span>
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </div>
        <div>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              <h6>Fatality Count</h6>
              <ul style={{ listStyle: "none" }} className="p-0">
                <li>
                  <span className="txtgrey">Employee:</span>
                  {fatalityEmployees}
                </li>
                <li>
                  <span className="txtgrey">Contractor:</span>
                  {fatalityContractors}
                </li>
                <li>
                  <span className="txtgrey">Other:</span>
                  {fatalityOthers}
                </li>
              </ul>
              <h6>Injuries Count</h6>
              <ul style={{ listStyle: "none" }} className="p-0">
                <li>
                  <span className="txtgrey">Employee:</span>
                  {injuredEmployees}
                </li>
                <li>
                  <span className="txtgrey">Contractor:</span>
                  {injuredContractors}
                </li>
                <li>
                  <span className="txtgrey">Other:</span>
                  {injuredOthers}
                </li>
              </ul>
              <h6>Manhour Lost</h6>
              <ul style={{ listStyle: "none" }} className="p-0">
                <li>
                  <span className="txtgrey">Employee:</span>
                  {lostManhoursEmployees}
                </li>
                <li>
                  <span className="txtgrey">Contractor:</span>
                  {lostManhoursContractors}
                </li>
                <li>
                  <span className="txtgrey">Other:</span>
                  {lostManhoursOthers}
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </div>
        <div>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="4"
            onClick={() => customOnClick(4)}
            className={panelIndex === 4 ? "active" : ""}
          >
            Personnel Details
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="4">
            <Card.Body>
              {!personalDetails.length ? (
                <div className="text-danger">Not Applicable</div>
              ) : (
                personalDetails.map((data, index) => (
                  <div key={index} className="detailsGroup">
                    <ul style={{ listStyle: "none" }} className="p-0">
                      <li>
                        <span className="txtgrey">Type:</span>
                        <span className="rightData">{data.type}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Name:</span>
                        <span className="rightData">{data.name}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Employer:</span>
                        <span className="rightData">
                          {data.type === "Contractor"
                            ? contractors?.find((d) => d.id === +data?.employer)
                                ?.contractorLegalEntity || ""
                            : data?.employer}
                        </span>
                      </li>
                      <li>
                        <span className="txtgrey">ID:</span>
                        <span className="rightData">{data.userId}</span>
                      </li>
                      {/* <li>
                        <span className="txtgrey">Phone:</span>
                        <span className="rightData">{data.phone}</span>
                      </li> */}
                      <li>
                        <span className="txtgrey">Age:</span>
                        <span className="rightData">{data.age}</span>
                      </li>
                    </ul>
                    <ul style={{ listStyle: "none" }} className="p-0">
                      <li>
                        <span className="txtgrey">Injury Type:</span>
                        <span className="rightData">{data.injuryType}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Severity:</span>
                        <span className="rightData">{data.severity}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Body Parts Involved:</span>
                        <span className="rightData">
                          {/* {bodyLabel[data.bodyParts]} */}
                          <BodyPartView bodyParts={data?.bodyParts} />
                        </span>
                      </li>
                      <li>
                        <span className="txtgrey">Outcome:</span>
                        <span className="rightData">{data.outcome}</span>
                      </li>
                      <li>
                        <span className="txtgrey">LTI Hours:</span>
                        <span className="rightData">{data.ltiHours} Hour(s)</span>
                      </li>
                    </ul>
                  </div>
                ))
              )}
            </Card.Body>
          </Accordion.Collapse>
        </div>
        <div>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="5"
            onClick={() => customOnClick(5)}
            className={panelIndex === 5 ? "active" : ""}
          >
            Equipment Details
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="5">
            <Card.Body>
              {!assetDetails.length ? (
                <div className="text-danger">Not Applicable</div>
              ) : (
                assetDetails.map((data, index) => (
                  <div key={index} className="detailsGroup">
                    <ul style={{ listStyle: "none" }} className="p-0">
                      <li>
                        <span className="txtgrey">SKU:</span>
                        <span className="rightData">{data.sku}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Type:</span>
                        <span className="rightData">MAT {data.type}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Name:</span>
                        <span className="rightData">{data.name}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Details:</span>
                        <span className="rightData">{data.details}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Damage:</span>
                        <span className="rightData">{data.damage}</span>
                      </li>
                    </ul>
                  </div>
                ))
              )}
            </Card.Body>
          </Accordion.Collapse>
        </div>
        <div>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="6"
            onClick={() => customOnClick(6)}
            className={panelIndex === 6 ? "active" : ""}
          >
            Vehicle Details
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="6">
            <Card.Body>
              {!vehicleDetails.length ? (
                <div className="text-danger">Not Applicable</div>
              ) : (
                vehicleDetails.map((data, index) => (
                  <div key={index} className="detailsGroup">
                    <ul style={{ listStyle: "none" }} className="p-0">
                      <li>
                        <span className="txtgrey">Number:</span>
                        <span className="rightData">{data.number}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Type:</span>
                        <span className="rightData">{data.type}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Owner:</span>
                        <span className="rightData">{data.owner}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Driver Name:</span>
                        <span className="rightData">{data.driverName}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Observation:</span>
                        <span className="rightData">{data.observation}</span>
                      </li>
                      <li>
                        <span className="txtgrey">Insurance Status:</span>
                        <span className="rightData">{data.insuranceStatus}</span>
                      </li>
                    </ul>
                  </div>
                ))
              )}
            </Card.Body>
          </Accordion.Collapse>
        </div>

        <div>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="8"
            onClick={() => customOnClick(8)}
            className={panelIndex === 8 ? "active" : ""}
          >
            Incident Evidence
            <span style={{ float: "right" }}>
              <MdKeyboardArrowRight />
            </span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="8">
            <Card.Body>
              {evidences?.length ? (
                evidences.map((data) => <EvidenceDetailsInfo key={data.id} {...data} />)
              ) : (
                <div className="text-danger">Not Applicable</div>
              )}
            </Card.Body>
          </Accordion.Collapse>
        </div>
        {capasDetails?.length > 0 && (
          <div>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="9"
              onClick={() => customOnClick(9)}
              className={panelIndex === 9 ? "active" : ""}
            >
              CAPA Details
              <span style={{ float: "right" }}>
                <MdKeyboardArrowRight />
              </span>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="9">
              <Card.Body>
                {!capasDetails ? (
                  <div className="text-danger">Not Applicable</div>
                ) : (
                  capasDetails.map((data, index) => (
                    <div key={index} className="detailsGroup">
                      <ul style={{ listStyle: "none" }} className="p-0">
                        <li>
                          <span className="txtgrey">CAPA Id:</span>
                          <span className="rightData">{data.capaId}</span>
                        </li>
                        <li>
                          <span className="txtgrey">CAPA Type:</span>
                          <span className="rightData">{data.capaType}</span>
                        </li>
                        <li>
                          <span className="txtgrey">CAPA Description:</span>
                          <span className="rightData">{data.solution}</span>
                        </li>
                        <li>
                          <span className="txtgrey">Area:</span>
                          <span className="rightData">{area?.name}</span>
                        </li>
                        <li>
                          <span className="txtgrey">Sub Area:</span>
                          <span className="rightData">{subArea?.name}</span>
                        </li>
                        <li>
                          <span className="txtgrey">CAPA Owner:</span>
                          <span className="rightData">
                            {data.owner?.firstName + data.owner?.lastName}
                          </span>
                        </li>
                        <li>
                          <span className="txtgrey">Priority:</span>
                          <span className="rightData">{data.priority}</span>
                        </li>
                        <li>
                          <span className="txtgrey">Due Date:</span>
                          <span className="rightData">{data.dueDate}</span>
                        </li>
                      </ul>
                    </div>
                  ))
                )}
              </Card.Body>
            </Accordion.Collapse>
          </div>
        )}
      </Accordion>
    </div>
  );
};

export default withRouter(IncidentDetailsInfo);
